module.exports = {
  sentryConfig: {
    orgID: '181626',
    projectID: '4506222504968192',
    org: 'cofit',
    project: 'corona',
    tunnelPath: '/monitoring',
    enableSentry: !process.env.NEXT_PUBLIC_CI_TEST && true,
    sentryCDN: 'https://js.sentry-cdn.com/527609e7065c8d36b71712fd4865fee8.min.js',
    dsn: 'https://527609e7065c8d36b71712fd4865fee8@o181626.ingest.sentry.io/4506222504968192'
  }
};